import { MouseEvent } from "react";
import React, { useState } from "react";
import ctbmsLogo from "../../assets/img/ctbms-logo-new.jpeg";


const CountsComponent = () => {
    return (
        <section className="py-20 bg-gradient-to-br from-[#4A0404] to-[#800000] text-white">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
                    <div className="text-center number-block">
                        <div className="text-5xl md:text-6xl mb-2 font-bold number-block-number">50+</div>
                        <p className="text-xl text-white/90 number-block-text">ವರ್ಷಗಳ ಸೇವೆ</p>
                    </div>
                    <div className="text-center number-block">
                        <div className="text-5xl md:text-6xl mb-2 font-bold number-block-number">1300+</div>
                        <p className="text-xl text-white/90 number-block-text">ಸದಸ್ಯರು</p>
                    </div>
                    <div className="text-center number-block">
                        <div className="text-5xl md:text-6xl mb-2 font-bold number-block-number">100+</div>
                        <p className="text-xl text-white/90 number-block-text">ಕಾರ್ಯಕ್ರಮಗಳು</p>
                    </div>                    
                </div>
            </div>
        </section>
    );
};
export default CountsComponent; 